import * as _ from "lodash";
import moment from "moment";

export class VenueNote {
  constructor(date, venueDetailsId) {
    this.id = undefined;
    this.venueNoteId = { id: this.id};
    this.date = date;
    this.message = '';
    this.type = undefined;
    this.created = undefined;
    this.createdBy = undefined;
    this.updated = undefined;
    this.updatedBy = undefined;
    this.deleted = undefined;
    this.venueDetailsId = venueDetailsId;
    this.bookingClosed = false;
  }

  isValid() {
    let valid = !!this.date && !!this.message && !!this.message.trim() && !!this.venueDetailsId;
    return valid;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    const note =  Object.assign(new VenueNote(), json);
    return note;
  }
}
